// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2hGOp","modalForm":"UpgradeEpcsModal_modalForm__2dnF-","modalFooter":"UpgradeEpcsModal_modalFooter__kb2IJ"};